import React from "react";
import { useAdminStore } from "@/store/useAdminStore";
import { useHandleGetOffer } from "@/Modules/ModularConfigurator/hooks/handleSubmitHook";
import { Input } from "@/Components/ui/input";
import { Button } from "@/Components/ui/button";
import { useTranslation } from "@/hooks/use-translation";

export default function Offer() {
   const { formData, formErrors, setFormData, validateField } = useAdminStore();
   const { handleGetOffer } = useHandleGetOffer();
   const { translation } = useTranslation();
   const { offer } = translation;

   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      setFormData(name, value);
      validateField(name, value);
   };

   const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      handleGetOffer();
   };

   return (
      <div className="flex flex-col items-center gap-4 pb-10">
         {/* Heading */}
         <h2 className="text-[40px] leading-[113%] text-custom-dark">
            {offer.heading}
         </h2>
         <p className="text-[16px] leading-[172%] text-custom-dark/60 text-center">
            {offer.description}
         </p>

         {/* Form */}
         <form onSubmit={handleSubmit} className="w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-[40px]">
               {/* Render each field */}
               {(
                  Object.keys(offer.fields) as Array<keyof typeof offer.fields>
               ).map((fieldKey) => (
                  <div key={fieldKey} className="flex flex-col">
                     <label
                        htmlFor={fieldKey}
                        className="text-d-body-m-paragraph text-custom-dark mb-1"
                     >
                        {offer.fields[fieldKey].label}
                     </label>
                     <Input
                        id={fieldKey}
                        name={fieldKey}
                        type={fieldKey === "email" ? "email" : "text"}
                        placeholder={offer.fields[fieldKey].placeholder}
                        value={formData[fieldKey] ?? ""}
                        onChange={handleChange}
                     />
                     {formErrors[fieldKey] && (
                        <span className="mt-1 text-red-600 text-sm">
                           {formErrors[fieldKey]}
                        </span>
                     )}
                  </div>
               ))}
            </div>

            <Button variant="l-white" className="w-full">
               {offer.button.submitRequest}
            </Button>
         </form>

         {/* Privacy text */}
         <p className="text-d-body-m-paragraph text-custom-dark/60 text-center">
            {offer.privacy}
         </p>
      </div>
   );
}
